export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/coupe.ab9568bf.svg","height":28,"width":88,"blurWidth":0,"blurHeight":0};